import { FC } from 'react';
import useValidateVisibleCondition from '../../../../hooks/useValidateVisibleCondition';
import {
  AnswerApplicationQuestionRequest,
  FieldObject,
} from '../../../../openapi/atlantis';
import ConfigDrivenFormFieldArrayInputV2 from './ConfigDrivenFormFieldArrayInputV2';

interface ConfigDrivenConditionalFormFieldArrayInputV2Props {
  field: FieldObject;
  onSubmit: (e: AnswerApplicationQuestionRequest) => void;
  isSubmitting: boolean;
  checklistItemId: string;
  onNavigateToQuestion?: (questionId: string) => Promise<void>;
}

const ConfigDrivenConditionalFormFieldArrayInputV2: FC<
  ConfigDrivenConditionalFormFieldArrayInputV2Props
> = ({
  field,
  onSubmit,
  isSubmitting,
  checklistItemId,
  onNavigateToQuestion,
}) => {
  const { validateFieldVisibleCondition } = useValidateVisibleCondition();
  const isVisible = validateFieldVisibleCondition(field);

  if (!isVisible) {
    return null;
  }

  return (
    <ConfigDrivenFormFieldArrayInputV2
      fieldArray={field}
      onSubmit={onSubmit}
      isSubmitting={isSubmitting}
      checklistItemId={checklistItemId}
      onNavigateToQuestion={onNavigateToQuestion}
    />
  );
};
export default ConfigDrivenConditionalFormFieldArrayInputV2;
